// Riquadro "中文" nelle finestre del CRM (news, catalogo): la traduzione cinese fatta dall'AI locale al
// salvataggio. Si può correggere a mano; "Traduci di nuovo" rifà la traduzione dall'italiano.
// Se un campo cinese resta vuoto, al salvataggio viene tradotto in automatico.
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Languages, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/area-clienti-studio`;

// campi: [[chiave, etichetta, lungo?]]; form contiene sia "chiave" (italiano) sia "chiave_zh"
export default function CampiCinese({ form, setForm, campi }) {
  const [aperto, setAperto] = useState(false);
  const [attesa, setAttesa] = useState(false);
  const traduci = async () => {
    setAttesa(true);
    try {
      const testi = Object.fromEntries(campi.map(([k]) => [k, form[k] || '']));
      const r = (await axios.post(`${API}/traduci`, { testi })).data.testi;
      setForm((f) => ({ ...f, ...Object.fromEntries(campi.map(([k]) => [`${k}_zh`, r[k] || ''])) }));
      toast.success('Traduzione aggiornata: controllala e salva');
    } catch (err) { toast.error(err.response?.data?.detail || 'Traduzione non riuscita'); } finally { setAttesa(false); }
  };
  const vuoti = campi.filter(([k]) => form[k] && !form[`${k}_zh`]).length;
  return (
    <div className="rounded-lg border border-red-100 bg-red-50/40">
      <button type="button" onClick={() => setAperto(!aperto)} className="w-full flex items-center gap-2 px-3 py-2 text-sm font-medium text-red-900">
        <Languages className="w-4 h-4" /> 中文 · versione cinese
        <span className="text-xs font-normal text-slate-500">{vuoti ? 'si traduce in automatico al salvataggio' : 'tradotta: puoi correggerla'}</span>
        <span className="ml-auto text-xs text-slate-500">{aperto ? 'chiudi' : 'apri'}</span>
      </button>
      {aperto && (
        <div className="px-3 pb-3 space-y-2">
          {campi.map(([k, etichetta, lungo]) => (
            <div key={k}>
              <Label className="text-xs">{etichetta} (cinese)</Label>
              {lungo
                ? <Textarea rows={4} value={form[`${k}_zh`] || ''} onChange={(e) => setForm({ ...form, [`${k}_zh`]: e.target.value })} />
                : <Input value={form[`${k}_zh`] || ''} onChange={(e) => setForm({ ...form, [`${k}_zh`]: e.target.value })} />}
            </div>
          ))}
          <Button type="button" size="sm" variant="outline" onClick={traduci} disabled={attesa}>
            {attesa ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Languages className="w-4 h-4 mr-1" />} Traduci di nuovo dall'italiano</Button>
          <p className="text-xs text-slate-500">Traduzione fatta dall'AI dello studio (xieai), niente cloud. Se cambi il testo italiano, al salvataggio si ritraduce da solo.</p>
        </div>
      )}
    </div>
  );
}
